module.exports = __webpack_public_path__ + "media/images/icons/twotone/file-pdf-c0eafe0edc862b2f65ffc50c1628edc4.svg";